import {AccordionDetails} from '@mui/material';

import JobPostingAccordionDetailsBody from './AccordionDetailsBody';
import JobPostingsAccordionDetailsHeader from './AccordionDetailsHeader';
import {CompanyLocation, JobPosting} from '../../types/JobPostingsTypes';

interface JobPostingAccordionDetailsProps {
  jobPosting: JobPosting;
  renderJobPostingLocations: (jobPosting: JobPosting) => any;
  companyId: string;
  handleUpdateJobPosting(jobPosting: JobPosting): void;
  handleDeleteJobPosting(jobPosting: JobPosting): void;
  handleJobPostingStatusChange(jobPosting: JobPosting | undefined, action: 'archive' | 'activate'): void;
  companyLocations: CompanyLocation[];
  renderIconStatus(jobPosting: JobPosting): any;
}

export default function JobPostingsAccordionDetails({
  jobPosting,
  renderJobPostingLocations,
  companyId,
  handleUpdateJobPosting,
  handleDeleteJobPosting,
  handleJobPostingStatusChange,
  companyLocations,
  renderIconStatus,
}: JobPostingAccordionDetailsProps) {
  return (
    <AccordionDetails
      sx={{
        backgroundColor: 'white',
        padding: '32px',
      }}
    >
      <JobPostingsAccordionDetailsHeader
        jobPosting={jobPosting}
        renderJobPostingLocations={renderJobPostingLocations}
        companyId={companyId}
        handleUpdateJobPosting={handleUpdateJobPosting}
        handleDeleteJobPosting={handleDeleteJobPosting}
        handleJobPostingStatusChange={handleJobPostingStatusChange}
        companyLocations={companyLocations}
        renderIconStatus={renderIconStatus}
      />
      <JobPostingAccordionDetailsBody jobPosting={jobPosting} />
    </AccordionDetails>
  );
}
